import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'

export const DIALOG_FAILED_TO_CANCEL_ORDER_KEY = 'DialogFailedToCancelOrder'

export interface DialogFailedToCancelOrderProps {
  header: string
  content: string
}

export function DialogFailedToCancelOrder() {
  const { open, closeDialog, header, content } = useDialog<DialogFailedToCancelOrderProps>(DIALOG_FAILED_TO_CANCEL_ORDER_KEY)

  return (
    <Dialog disablePortal open={open} maxWidth={320}>
      <DialogHeader py={3}>{header}</DialogHeader>
      <DialogContent py={3}>
        <Text align="center">{content}</Text>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} fullWidth>確認</Button>
      </DialogActions>
    </Dialog>
  )
}
